import {gsap} from "gsap";
import {NineToFiveSymbol, SymbolArgs} from "./NineToFiveSymbol";
import {ReelView} from "../../../core/reel/simplereel/SimpleReelModel";
import {NineToFive} from "../../NineToFive";
import {NineToFiveGameAssets} from "../../NineToFiveGameAssets";
import {SpineGSAPWrapper} from "../../animation/SpineGSAPWrapper";

export class NineToFiveWildSymbol extends NineToFiveSymbol {
    public multiplier:number;

    constructor(args:SymbolArgs) {
        super(args);
        this.view.removeChild(this.winAnimation);
        this.winAnimation = new PIXI.spine.Spine(NineToFive.assetLoader.getSpineAsset(NineToFiveGameAssets.SYMBOL_WILD));
        this.view.addChild(this.winAnimation);
        this.multiplier = args.symbolSize;
        this.view.removeChild(this.winBlink);
        this.view.removeChild(this.overlay);
        this.view.addChild(this.winBlink);
        this.view.addChild(this.overlay);
    }

    public revealMultiplier():gsap.core.Timeline {
        const endClip = `W_End_${this.multiplier > 0 ? `Yes_X${this.multiplier}` : "No"}`;
        const idleClip = `W_Idle_${this.multiplier > 0 ? `X${this.multiplier}` : "No"}`;
        return gsap.timeline()
            .add(() => {
                this.winAnimation.alpha = 1
                this.moveToWinLayer();
            })
            .add(SpineGSAPWrapper.createTimeline(this.winAnimation, 0, "W_Shuffle"))
            .add(SpineGSAPWrapper.createTimeline(this.winAnimation, 0, endClip))
            .add(() => {
                this.winAnimation.state.setAnimation(0, idleClip, true);
                this.moveToNormalLayer();
            });
    }

    public getWinAnimationBased():gsap.core.Timeline {
        return this.multiplier > 0
            ? gsap.timeline()
                .add(() => {
                    this.moveToWinLayer();
                })
                .add(SpineGSAPWrapper.createTimeline(this.winAnimation, 0, `W_Win_X${this.multiplier}`))
                .add(() => {
                    this.winAnimation.state.setAnimation(0, `W_Idle_X${this.multiplier}`, true);
                    this.moveToNormalLayer();
                })
            : gsap.timeline();
    }

    public resetState(): gsap.core.Timeline {
        return gsap.timeline().add(() => {
            this.winAnimation.state.setAnimation(0,
                                                 this.multiplier > 0
                                                 ? `W_Idle_X${this.multiplier}`
                                                 : "W_Idle_No",
                                                 true);
            this.moveToNormalLayer();
            this.overlay.alpha = 0;
        })
    }

    public restore():void {
        const idleClip = `W_Idle_${this.multiplier > 0 ? `X${this.multiplier}` : "No"}`;
        this.winAnimation.state.setAnimation(0, idleClip, true);
    }
}
